import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface TestModeContextType {
  isTestMode: boolean;
  toggleTestMode: () => void;
  setTestMode: (value: boolean) => void;
}

const TestModeContext = createContext<TestModeContextType | undefined>(undefined);

export function TestModeProvider({ children }: { children: ReactNode }) {
  useLanguage();
  const [isTestMode, setIsTestMode] = useState(() => {
    // Usar sessionStorage para não persistir entre sessões
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('hostvsl_test_mode') === 'true';
    }
    return false;
  });

  useEffect(() => {
    sessionStorage.setItem('hostvsl_test_mode', String(isTestMode));
  }, [isTestMode]);

  const toggleTestMode = () => {
    setIsTestMode(prev => !prev);
  };

  const setTestMode = (value: boolean) => {
    setIsTestMode(value);
  };

  return (
    <TestModeContext.Provider value={{ isTestMode, toggleTestMode, setTestMode }}>
      {children}
    </TestModeContext.Provider>
  );
}

export function useTestMode() {
  useLanguage();
  const context = useContext(TestModeContext);
  if (context === undefined) {
    throw new Error(translateInterfaceText("useTestMode must be used within a TestModeProvider"));
  }
  return context;
}
